module.exports = __webpack_public_path__ + "static/media/37_tn.8109d231.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/37_tn.jpg
// module id = 525
// module chunks = 0